import React from "react"
import PropTypes from "prop-types"

import {
  ConfirmationPage,
  ConfirmationPageSection,
  DataDisplay,
  DataDisplayPhoto,
  Loader,
  Seo,
} from "../../../../Shared"
import { returnHypenIfEmpty } from "../../../../../utilities"

export const MoreInfoNeededConfirmation = ({ callbackInfo, location }) => {
  const { images, notes, name, email, mobile, goodTimeToCall } = callbackInfo

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (name && email && mobile) {
    return (
      <ConfirmationPage
        heading="Details submitted"
        followUp="We’ll be in contact within 1-2 working days"
        note="We may contact you to survey your property"
      >
        <Seo
          url={location && location.href ? location.href : null}
          title="Details submitted | Home Assist Repairs and Servicing"
        />
        <ConfirmationPageSection>
          <DataDisplay label="Photos">
            {images.length > 0
              ? images.map((image, index) => (
                  <DataDisplayPhoto
                    key={index}
                    photoUrl={image}
                    photoDesc="Uploaded photo"
                  />
                ))
              : "-"}
          </DataDisplay>
          <DataDisplay label="Additional notes">
            {returnHypenIfEmpty(notes)}
          </DataDisplay>
        </ConfirmationPageSection>
        <ConfirmationPageSection>
          <DataDisplay label="Contact">
            {name}
            <br />
            {email}
            <br />
            {mobile}
          </DataDisplay>
          <DataDisplay label="Is there a good time for us to call?">
            {returnHypenIfEmpty(goodTimeToCall)}
          </DataDisplay>
        </ConfirmationPageSection>
      </ConfirmationPage>
    )
  } else {
    return <Loader error={true} errorText="Error loading data" text="" />
  }
}

MoreInfoNeededConfirmation.propTypes = {
  callbackInfo: PropTypes.shape({
    email: PropTypes.string.isRequired,
    goodTimeToCall: PropTypes.string.isRequired,
    homePhone: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.string),
    mobile: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    notes: PropTypes.string,
    quoteCallbackRequestNumber: PropTypes.number.isRequired,
    quoteId: PropTypes.string.isRequired,
    timestamp: PropTypes.string,
  }).isRequired,
}
